/*
 * Copyright (c) 2026. Bluemate B.V.
 */
import IDate from '@dvrd/idate';

import React from 'react';

import {useTranslation} from 'react-i18next';

import {BluemateProductRow, BluemateSectionCard} from '../../../controls';

import {DUTCH_DATE_FORMAT} from '../../../../util/constants';

import {OverviewReview} from '../../../../util/interfaces';

import {bolReviewsUrl} from '../../../../util/overviewUtil';

import {OverviewSectionState} from '../useOverviewSection';

export default function Reviews(props: OverviewSectionState<OverviewReview>) {
    const {items, loading, loadingMore, error, hasMore, onLoadMore} = props;
    const {t} = useTranslation();

    function renderRow(review: OverviewReview, index: number) {
        return (
            <BluemateProductRow
                key={index}
                imageUrl={review.image_url}
                title={review.title}
                titleHref={bolReviewsUrl(review.product_url)}
                ean={review.ean}
                subtitle={new IDate(review.review_date).format(DUTCH_DATE_FORMAT)}
                review={{
                    rating: review.rating,
                    title: review.review_title,
                    message: review.review_message,
                    author: review.author
                }}
            />
        );
    }

    return (
        <BluemateSectionCard
            title={t('overview.sections.reviews', 'Nieuwste reviews')}
            loading={loading}
            loadingMore={loadingMore}
            empty={!items.length}
            emptyLabel={t('overview.reviews.empty', 'Geen nieuwe reviews in deze periode')}
            error={error ? t('overview.sectionError', 'Deze sectie kon niet geladen worden') : undefined}
            hasMore={hasMore}
            loadMoreLabel={t('overview.loadMore', 'Meer laden')}
            onLoadMore={onLoadMore}
        >
            {items.map(renderRow)}
        </BluemateSectionCard>
    );
}
